module.exports = __webpack_public_path__ + "static/img/cop_sch_logo14.5e9917c5.png";